import { STATIC_FIELD_NAMES } from '../../fields/StaticField/constants';
import type { FieldQuery, FieldQueryData, ContestManageStore } from '../types/store';

export const getFieldQueryByField = (
  cache: ContestManageStore,
  field: FieldQuery
): FieldQueryData | null => {
  if (field.type === 'DynamicField' || field.type === 'DynamicFields') {
    const latestFieldQuery = cache.fieldsCache[field.latestQueryKey];

    if (!latestFieldQuery || latestFieldQuery.type !== field.type) {
      return {
        key: field.key,
        type: field.type,
        isLoading: false,
      };
    }

    return latestFieldQuery;
  }

  if (STATIC_FIELD_NAMES.includes(field.type)) {
    return field;
  }

  return null;
};
